import { makeStyles } from '@material-ui/core/styles'
import { FONTS, COLORS, BREAKPOINTS } from '../../constants'

export const styles = makeStyles(theme => ({
  uploadPicTitle: {
    [`@media (max-width: ${BREAKPOINTS.xsm}px)`]: {
      fontSize: '1.5rem',
      margin: '20px 0 15px',
    },
  },
  dialogContainer: {
    '& .MuiDialog-paper': {
      backgroundColor: COLORS.white,
      height: '98%',
      maxHeight: 700,
      width: '90%',
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  dialogContent: {
    padding: 0,
    position: 'relative',
    maxHeight: 400,
  },
  cropper: {
    position: 'relative',
    backgroundColor: COLORS.whiteStain,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 346,
    margin: 'auto',
    padding: 20,
    ['& canvas']: {
      borderRadius: '100%',
      height: '100% !important',
      width: '100% !important',
      maxHeight: '300px !important',
      maxWidth: '300px !important',
    },
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 20px',
    width: '100%',
    maxWidth: 386,
    margin: '20px auto 0px',
    ['& > button']: {
      fontFamily: FONTS.Graphik.GraphikMedium,
      fontSize: '0.75rem',
      marginRight: 0,
    },
    ['& > :not(:first-child)']: {
      marginLeft: 0,
    },
  },
  reset: {
    backgroundColor: theme.palette.common.black,
    width: 54,
    height: 54,
    position: 'absolute',
    top: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.common.black}`,
    cursor: 'pointer',
    [`@media (max-width: ${BREAKPOINTS.xsm}px)`]: {
      width: 45,
      height: 45,
    },
  },
  resetIcon: {
    width: 24,
    height: 24,
    display: 'block',
  },
  closeIcon: {
    width: 50,
    height: 50,
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 10,
    [`@media (max-width: ${BREAKPOINTS.xsm}px)`]: {
      width: 40,
      height: 40,
    },
  },

  // ----------------slider styles---------------- //

  root: {
    color: COLORS.lightGrey,
    height: 8,
    padding: 0,
    margin: '30px 10px 20px',
    width: '90%',
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: COLORS.black,
    border: `2px solid ${COLORS.white}`,
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  track: {
    height: 8,
    borderRadius: 4,
    color: COLORS.black,
  },
  active: {},
  rail: {
    height: 8,
    borderRadius: 4,
  },
}))
